(function($) {
  const windowIsDesktop = $(window).width() > 992; // lg screen size - need to make this happen on resize as well
  const dropEvent = windowIsDesktop ? 'mouseenter' : 'click'; // determine event based on window size

  $('[data-toggle="dropdown"]').on(dropEvent, function(e) {
    const dropElem = $(this).parent('.dropdown');
    const dropIsMega = dropElem.hasClass('dropdown-mega');
    let dropIsLarge = dropElem.data('size') >= 4; // Default way to do this
    const left = this.offsetLeft;
    const $dropMenu = dropElem.find('.dropdown-menu');

    if (!windowIsDesktop) {
      e.preventDefault();
    }

    if (dropIsMega && windowIsDesktop) {
      dropIsLarge = $dropMenu.find('[class^="col-"]').length > 4; // Here to account for inability to add [data-size] dynamically
      
      if (dropIsLarge) {
        $dropMenu.css('left', 0).css('right', 0);
      } else {
        $dropMenu.css('left', left);
      }
    }
    if (windowIsDesktop) {
      dropElem.addClass('dropdown-open');
    } else {
      dropElem.toggleClass('dropdown-open');
    }
  });

  // Checks on desktop if user mouseleaves to remove open class
  if (windowIsDesktop) {
    $('.dropdown').on('mouseleave', function() {
      $(this).removeClass('dropdown-open');
    });
  }
})(jQuery)
